export default function init() {
    $(document).on('click', '.link-outside', function(){ 
        $('.loader-container').removeClass('d-none');
        setTimeout(() => {
            $('.loader-container').addClass('d-none');
        }, 5000);
    });
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    $(document).on('click', "#notification-bell .dropdown-item, #notification-list-modal .dropdown-item", function(){
        $('#notification-list-modal .btn-close').trigger('click');
        let id = $(this).data("id");
        $.ajax({
            'url': '/ajax/update-notification-status',
            'method': 'POST',
            'data': {
                'notify_id': id
            },
            success: function(response){
                if(response.success){

                }
            },
            error: function(error){
                
            }
        });
    });
}